module.exports = __webpack_public_path__ + "img/connect-green-icon.0685741f.svg";